import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';
import { useMemo, FC } from 'react';
import { cn } from '@ui/utils';

export const PercentageBar: FC<{ className?: string; value: number }> = ({ value, className }) => {
  const { t } = useTranslation();
  const progressStyle = useMemo(() => {
    const progress = Math.min(100, Math.max(0, Math.ceil((100 + value) / 2)));
    return { left: `${progress}%` };
  }, [value]);

  const label = useMemo(() => {
    if (value === 0) return t('COST_CENTER.EXPENSES_SUMMARY.EQUAL');
    if (value > 0) return t('COST_CENTER.EXPENSES_SUMMARY.HIGHER');
    if (value === -100) return t('COST_CENTER.EXPENSES_SUMMARY.NO_EXPENSES_YET');
    return t('COST_CENTER.EXPENSES_SUMMARY.LOWER');
  }, [value, t]);

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <div className="flex items-center gap-4 justify-between">
        <div>
          <Typography variant="h200">{Math.abs(value)}%</Typography>
        </div>

        <div>
          <Typography variant="labelSmallBook" className="text-weak">
            {label}
          </Typography>
        </div>
      </div>

      <div className="flex items-center gap-0.25 relative w-full">
        <div className="flex-1 rounded-l-full h-4 bg-gradient-to-r from-cyan-200 to-blue-400" />
        <div className="flex-1 rounded-r-full h-4 bg-gradient-to-r from-blue-400 via-pink-400 to-red-400" />

        <div className="absolute top-0 left-2 right-2 h-full">
          <div
            className="rounded-full h-4 w-4 bg-default border-1 border-white absolute -translate-x-1/2"
            style={progressStyle}
          />
        </div>
      </div>
    </div>
  );
};
